var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Day"}},[_c('AttendToday')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }